import React from 'react'
import { Box } from '@hub/box'
import { Text } from '@hub/text'
import { Link } from '@hub/link'
import UtilityBox from '../utility-box-v2'
import UtilityBoxItem, { UtilityBoxItemIcons } from '../utility-box-item-v2'
import { Service } from '@scentregroup/shared/types/contentful-v1'
import locationLink from '../../helpers/location-link'
import formatTelephoneNumber from '../../helpers/telephone-number'

interface PlanVisitUtilityBoxProps {
  heading: string
  name?: string
  address?: string
  address2?: string
  phoneNumber: string
  email: string
  conciergeService?: Service
  centreSlug: string
  latitude?: number
  longitude?: number
  country: string
}

const PlanVisitUtilityBox: React.FunctionComponent<
  React.PropsWithChildren<PlanVisitUtilityBoxProps>
> = ({
  heading,
  name,
  address,
  address2,
  phoneNumber,
  email,
  conciergeService,
  centreSlug,
  latitude,
  longitude,
  country,
}) => (
  <UtilityBox>
    {address && (
      <Box sx={{ marginBottom: 'spacing-xl' }}>
        <Text
          tone="strong"
          fontSize="font-2xl"
          color="textPrimary"
          sx={{
            marginBottom: 'spacing-md',
          }}
        >
          Address
        </Text>
        <UtilityBoxItem
          icon={UtilityBoxItemIcons.LOCATION_DROP_PIN}
          role="heading"
          aria-label="Store Location"
          aria-level="4"
        >
          {name && (
            <Text
              tone="strong"
              fontSize="font-md"
              color="textPrimary"
              sx={{
                marginBottom: 'spacing-md',
              }}
            >
              {name}
            </Text>
          )}
          <Text sx={{ paddingBottom: 'spacing-sm' }}>{address}</Text>
          {address2 && (
            <Text sx={{ paddingBottom: 'spacing-md' }}>{address2}</Text>
          )}
          {latitude && longitude && (
            <Link
              hasUnderline
              href={locationLink(latitude, longitude)}
              target="_blank"
            >
              Get directions
            </Link>
          )}
        </UtilityBoxItem>
      </Box>
    )}
    <Text
      tone="strong"
      fontSize="font-2xl"
      color="textPrimary"
      sx={{
        marginBottom: 'spacing-md',
      }}
    >
      {heading}
    </Text>
    <UtilityBoxItem
      icon={UtilityBoxItemIcons.PHONE}
      role="heading"
      aria-level="4"
      aria-label="Phone Number"
    >
      <Link href={`tel:${formatTelephoneNumber(phoneNumber, country)}`}>
        {phoneNumber}
      </Link>
    </UtilityBoxItem>
    <UtilityBoxItem
      icon={UtilityBoxItemIcons.EMAIL}
      role="heading"
      aria-level="4"
      aria-label="Email Address"
    >
      <Link href={`mailto:${email}`}>Email us</Link>
    </UtilityBoxItem>

    {conciergeService?.store && (
      <UtilityBoxItem icon={UtilityBoxItemIcons.HOURS}>
        <Link
          href={`/${centreSlug}/service/${conciergeService.sys.id}/${conciergeService.slug}`}
          target="_blank"
        >
          View Concierge Hours
        </Link>
      </UtilityBoxItem>
    )}
  </UtilityBox>
)

export default PlanVisitUtilityBox
